<template>
  <el-dialog :visible="show" width="800px" :show-close="false" append-to-body class="question-background-modal">
    <span slot="title" class="modal-title">{{ title }}：题目背景</span>
    <div class="modal-content" v-html="$xss(questionBackground)"></div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleClose">收起题目背景</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { Button, Dialog } from 'element-ui'
export default {
  name: 'QuestionBackgroundModal',
  components: {
    ElButton: Button,
    ElDialog: Dialog
  },
  data() {
    return {
      show: false,
      title: '',
      questionBackground: ''
    }
  },
  methods: {
    handleClose() {
      this.show = false
    },
    handleOpen(title, questionBackground) {
      this.show = true
      this.title = title
      this.questionBackground = questionBackground
    }
  }
}
</script>

<style scoped>
.question-background-modal >>> .el-dialog__body {
  padding: 24px 32px 0 32px;
}
.modal-title {
  font-size: 22px;
  font-weight: bold;
}

.modal-content {
  font-size: 16px;
  margin-bottom: 24px;
  text-align: left;
}
.modal-images {
  display: flex;
  justify-content: center;
  gap: 32px;
  margin-bottom: 16px;
}
.modal-img {
  width: 120px;
  height: 120px;
  object-fit: contain;
  border: 1px solid #eee;
  background: #fafafa;
  border-radius: 8px;
}
.dialog-footer {
  text-align: center;
}
</style>
